export const ORDER_FOR_ME_VALUE = 'MYSELF';
export const ORDER_FOR_SOMEONE_ELSE_VALUE = 'SOMEONE_ELSE';
